export const initEntryTime = () => {
  const inputTime = document.getElementById('input-time');

  if (!inputTime) return;

  const now = new Date();

  const yy = now.getFullYear();
  const mm = now.getMonth() + 1;
  const dd = now.getDate();
  const h = String(now.getHours()).padStart(2, '0');
  const m = String(now.getMinutes()).padStart(2, '0');

  inputTime.value = `${yy}年${mm}月${dd}日 ${h}:${m}`;
};